export default __webpack_public_path__ + "static/mixkit-keep-dancin-811-923382bf8e6c1e15df301e93b3125c9b.mp3";